import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { ImportedResource } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 2620. インポート一覧
 * [GET] /workspaces/:identifier/imported_resources
 */
type Props = {
  identifier: string;
};
const importedResources = (props: Props): Promise<ImportedResource[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/imported_resources`, {
    params: props,
  });
};

export const useImportedResources = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => importedResources(props),
  });
};

export const useInvalidateImportedResources = (props: Props) => {
  const invalidate = async () => {
    await queryClient.invalidateQueries({
      queryKey: queryKey(props),
    });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'imported_resources'];
};
